import * as React from "react";
import { useState, useCallback, useMemo } from "react";
import { arrayMove, horizontalListSortingStrategy, SortableContext } from "@dnd-kit/sortable";
import {
  PointerSensor,
  DndContext,
  useSensors,
  useSensor,
  MouseSensor,
  TouchSensor,
  KeyboardSensor,
  DragOverlay
} from "@dnd-kit/core";
import { createPortal } from "react-dom";
import { UTILITY_COLUMNS } from "components/common/EntityDataTable/Constants";
import ThDragOverlay from "components/common/EntityDataTable/ThDragOverlay";
import DndStylesProvider from "components/common/EntityDataTable/contexts/DndStylesProvider";
import zIndices from "theme/z-indices";
import useDndCollisionDetection from "components/common/EntityDataTable/hooks/useDndCollisionDetection";
const TableDndProvider = ({ children = void 0, table }) => {
  const [activeId, setActiveId] = useState(null);
  const columnOrder = table.getState().columnOrder;
  const draggableColumns = useMemo(() => columnOrder.filter((id) => !UTILITY_COLUMNS.has(id)), [columnOrder]);
  const { collisionDetection, setLastOverId } = useDndCollisionDetection(draggableColumns);
  const activeColumn = useMemo(
    () => activeId ? table.getAllColumns().find((col) => col.id === activeId) : void 0,
    [activeId, table]
  );
  const sensors = useSensors(
    useSensor(MouseSensor, {}),
    useSensor(TouchSensor, {}),
    useSensor(PointerSensor, {}),
    useSensor(KeyboardSensor, {})
  );
  const handleDragStart = useCallback(
    ({ active }) => {
      setActiveId(active.id);
      setLastOverId(active.id);
    },
    [setLastOverId]
  );
  const handleDragEnd = useCallback(
    (event) => {
      const { active, over } = event;
      if (active && (over == null ? void 0 : over.id) && active.id !== over.id) {
        table.setColumnOrder((curColumnOrder) => {
          const oldIndex = curColumnOrder.indexOf(active.id.toString());
          const newIndex = curColumnOrder.indexOf(over.id.toString());
          return arrayMove(curColumnOrder, oldIndex, newIndex);
        });
      }
    },
    [table]
  );
  return /* @__PURE__ */ React.createElement(
    DndContext,
    {
      collisionDetection,
      onDragEnd: handleDragEnd,
      onDragStart: handleDragStart,
      sensors
    },
    /* @__PURE__ */ React.createElement(SortableContext, { items: draggableColumns, strategy: horizontalListSortingStrategy }, /* @__PURE__ */ React.createElement(DndStylesProvider, null, children)),
    createPortal(
      /* @__PURE__ */ React.createElement(DragOverlay, { dropAnimation: null, zIndex: zIndices.modalBody }, activeColumn ? /* @__PURE__ */ React.createElement(ThDragOverlay, { column: activeColumn }) : null),
      document.body
    )
  );
};
export default TableDndProvider;
